import { Private_Routes } from '@common/url';
import { CheckPenIcon } from '@prophecy/icons';
import { theme, BaseColor } from '@prophecy/theme';
import { Stack, Text, RadialIconContainer, Dialog } from '@prophecy/ui-v3';
import { useNavigate } from 'react-router-dom';

import { TranspilerVersionType } from '../../../../../data/apis/transpileTypes';
import { TabDetailTypes } from '../../../ImportedInfo/types';
import { useImportState } from '../../useImportState';

export const CompleteStepDialog = () => {
  const {
    transpilerState: { transpilerId, activeStep },
    transpileGraphState: {
      clientState: {
        savedEntities: { isConfigGeneration }
      }
    },
    formDataWithActions: {
      formContext: { getValues }
    }
  } = useImportState();

  const navigate = useNavigate();
  const onClick = () => {
    navigate(
      Private_Routes.TranspilerDetail.getUrl(
        {
          uid: transpilerId,
          version: TranspilerVersionType.v2,
          type: getValues('source')
        },
        { tab: isConfigGeneration ? TabDetailTypes.configs : TabDetailTypes.overview }
      )
    );
  };

  return (
    <Dialog
      isBlocking={true}
      closable={false}
      okButton={{ children: isConfigGeneration ? 'View Bundle Configs' : 'View Bundle Details', block: true }}
      onOk={onClick}
      open={activeStep === 5}
      closeButton={null}
      data-test-id='transpiler-complete-step-dialog'>
      <Stack gap={theme.spaces.x16} alignY='center' padding={theme.spaces.x24} width='100%'>
        <RadialIconContainer size={theme.spaces.x64} tone={BaseColor.success}>
          <CheckPenIcon size='l' type='extended' color={theme.colors.success500} />
        </RadialIconContainer>
        <Stack width='100%' alignY='center' gap={theme.spaces.x8}>
          <Text level='xl' weight={theme.fontWeight.medium} tone={theme.colors.gray900}>
            {isConfigGeneration ? 'Config Generation' : 'Prophecy Migration'}
          </Text>
          <Text level='xl' weight={theme.fontWeight.medium} tone={theme.colors.gray900}>
            Successfully Completed
          </Text>
        </Stack>
      </Stack>
    </Dialog>
  );
};
